export default __webpack_public_path__ + "static/media/kitchen5-beforeA-1920w.f4f2e1ff.webp";